import React from 'react';
import {
  Dialog, DialogContent, DialogActions, Stack, TextField, Button,
  useMediaQuery, useTheme,
} from '@mui/material';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import ModalHeader from '../ui/ModalHeader';

export function JobResultEditDialog({
  open, value, onValueChange, poNumber, onPoNumberChange, saving, onClose, onConfirm,
}) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      fullScreen={fullScreen}
      PaperProps={{ sx: { borderRadius: fullScreen ? 0 : 3 } }}
    >
      <ModalHeader
        icon={<EditOutlinedIcon fontSize="small" />}
        title="แก้ไขผลการปิดงาน"
        onClose={onClose}
        disabled={saving}
      />
      <DialogContent sx={{ p: 3 }}>
        <Stack spacing={2}>
          <TextField
            label="มูลค่างาน" size="small" fullWidth type="number"
            value={value}
            onChange={(e) => onValueChange(e.target.value)}
          />
          <TextField
            label="เลขที่ PO" size="small" fullWidth
            value={poNumber}
            onChange={(e) => onPoNumberChange(e.target.value)}
          />
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, py: 2, borderTop: '1px solid', borderColor: 'divider' }}>
        <Button onClick={onClose} variant="outlined" sx={{ borderRadius: 2 }} disabled={saving}>ยกเลิก</Button>
        <Button onClick={onConfirm} variant="contained" disabled={saving} sx={{ borderRadius: 2 }}>
          {saving ? 'กำลังบันทึก...' : 'บันทึก'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default JobResultEditDialog;
